import { MICROSTORE_COLUMN_GROUP_WITH_COLUMNS_FRAGMENT } from 'data/fragments/microstoreColumnGroup';
import gql from 'graphql-tag';

export const SITE_FRAGMENT = gql`
    fragment SiteFragment on Site {
        _id
        accessTime
        unknownShrinkageBillingThreshold
        removalDate
        closingDatesRanges {
            start
            end
        }
        createdAt
        deliveryDays
        freshReassortDays
        dryReassortDays
        deliveryTimeWindow {
            start
            stop
        }
        deliveryType
        contractType
        estimatedUserCount
        hasExternalSetupProcess
        isOpenOnWeekend
        isSecured
        hasSensei
        hasCoffee
        launchDate
        name
        organizationId
        organizationName
        reassortmentFreshFacings {
            dessert
            main
            smallBites
            starter
        }
        reassortmentStockTargetRatios {
            monday
            tuesday
            wednesday
            thursday
            friday
        }
        reassortmentStockTargets {
            dessert
            main
            smallBites
            starter
        }
        reassortmentOnboardingStockTargets {
            dessert
            main
            smallBites
            starter
        }
        shouldOperateOnTotops
        shouldAutomaticallyCreateTargetReassortment
        shouldAutomaticallyCreateManualReassortment
        shouldAutomaticallyFinishSiteSetup
        shouldHaveTheftNotice
        shouldModulateForExpired
        shouldModulateForUnknownLosses
        state
        stateHistory {
            createdAt
            createdBy
            createdByName
            state
        }
        totemNumber
        type
        unwantedProductIds
        updatedAt
        urbantzMetadata {
            needsInventoryBoissons {
                evenWeek
                oddWeek
            }
            needsInventorySnack {
                evenWeek
                oddWeek
            }
            needsInventoryNonAlimentaire {
                evenWeek
                oddWeek
            }
            needsCleaningMachineNECTA {
                evenWeek
                oddWeek
            }
            needsSmallExpiryDateInventory {
                evenWeek
                oddWeek
            }
            replaceCompleteInventoryByZeroInventory {
                evenWeek
                oddWeek
            }
            needsPunctualExpiryDateInventory {
                evenWeek
                oddWeek
            }
        }
        useNayaxCard
        B2CPriceRange
        wantedProductIds
        avaSiteId
        avaClientId
        deliveryZoneId
        deliveryZone {
            _id
            name
            color
        }
    }
`;

export const SITE_FRAGMENT_FILTER = gql`
    fragment SiteFragmentFilter on Site {
        _id
        createdAt
        updatedAt
        deliveryDays
        deliveryType
        name
        organizationName
        organizationId
        state
        totemId
        type
        B2CPriceRange
        accessTime
        launchDate
        removalDate
        hasExternalSetupProcess
        estimatedUserCount
        isSecured
        shouldOperateOnTotops
        shouldAutomaticallyCreateTargetReassortment
        shouldAutomaticallyCreateManualReassortment
        shouldAutomaticallyFinishSiteSetup
        shouldModulateForExpired
        shouldHaveTheftNotice
        shouldModulateForUnknownLosses
        useNayaxCard
        hasSensei
        unknownShrinkageBillingThreshold
        deliveryZoneId
        deliveryZone {
            _id
            name
            color
        }
    }
`;

export const SITE_WITH_LOCATION_INFO_FRAGMENT = gql`
    fragment SiteWithLocationInfoFragment on Site {
        _id
        deliveryDays
        earliestDLCDateToKeepForStockCalculation
        isOpenOnWeekend
        isSecured
        name
        type
        state
        organizationName
        nextDeliveryDate
        reassortmentFreshFacings {
            dessert
            main
            smallBites
            starter
        }
        reassortmentStockTargets {
            dessert
            main
            smallBites
            starter
        }
        reassortmentOnboardingStockTargets {
            dessert
            main
            smallBites
            starter
        }
        microstoreColumnGroups {
            ...MicrostoreColumnGroupWithColumnsFragment
        }
    }
    ${MICROSTORE_COLUMN_GROUP_WITH_COLUMNS_FRAGMENT}
`;
